import script from "./imageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./imageModal.vue?vue&type=script&setup=true&lang=js"

import "./imageModal.vue?vue&type=style&index=0&id=74bf573a&lang=scss"

const __exports__ = script;

export default __exports__